module.exports = __webpack_public_path__ + "static/img/logo.cf052ee4.png";